import { useEffect, useMemo, useState } from "react";

const copia = (v) => (v === undefined ? undefined : JSON.parse(JSON.stringify(v)));

// Copia editable de una parte de la instalación (formato v2). Se reinicia cuando cambia lo guardado
// (después de guardar, de importar o de cambiar de instalación).
// `tomar(inst)` devuelve la parte a editar, p. ej. inst => ({ operations: inst.operations }).
export function useBorrador(inst, tomar) {
  const original = useMemo(() => (inst ? copia(tomar(inst)) : null), [inst]);
  const [borrador, setBorrador] = useState(original);
  const [invalidos, setInvalidos] = useState({});
  // cambia al recargar o descartar: usarla como `key` de los campos para que también se borre el texto inválido
  const [version, setVersion] = useState(0);

  useEffect(() => {
    setBorrador(copia(original));
    setInvalidos({});
    setVersion((v) => v + 1);
  }, [original]);

  const dirty = useMemo(() => JSON.stringify(borrador) !== JSON.stringify(original), [borrador, original]);
  const cambiar = (clave, valor) => setBorrador((b) => ({ ...b, [clave]: valor }));
  const marcarInvalidos = (clave, n) => setInvalidos((prev) => (prev[clave] === n ? prev : { ...prev, [clave]: n }));
  const totalInvalidos = Object.values(invalidos).reduce((a, n) => a + (n || 0), 0);

  return {
    borrador,
    cambiar,
    dirty,
    descartar: () => { setBorrador(copia(original)); setInvalidos({}); setVersion((v) => v + 1); },
    marcarInvalidos,
    invalidos: totalInvalidos,
    version,
  };
}
